export default {
  contents: [],
  loaded: false
};
